import React, { useEffect, useState } from 'react'
import Button from 'components/Common/Button'
import moment from 'moment-timezone'
import { getSlotMoment } from 'utils/helper'

export interface IPaginatedSlotsProps {
  slots: {
    slotStartDate: string
    slotStartTime: string
    slotEndDate: string
    slotEndTime: string
  }[]
  defaultStartTime?: string
  defaultEndTime?: string
  onClick: (slot) => void
  date: string
}
const PaginatedSlots = ({
  slots,
  date,
  onClick,
  defaultStartTime = '9:00',
  defaultEndTime = '17:00',
}: IPaginatedSlotsProps) => {
  const minDefaultStartTime = moment
    .max(getSlotMoment(slots[0].slotStartTime, date), getSlotMoment(defaultStartTime, date))
    .format('h:mm A')
  const defaultStartIndex = slots.findIndex((slot) =>
    getSlotMoment(slot.slotStartTime, date).isSameOrAfter(getSlotMoment(minDefaultStartTime, date))
  )

  const isAfterDefaultEndTime = getSlotMoment(slots[0].slotStartTime, date).isSameOrAfter(
    getSlotMoment(defaultEndTime, date)
  )
  const maxDefaultEndTime = isAfterDefaultEndTime
    ? getSlotMoment(slots[slots.length - 1].slotStartTime, date).format('h:mm A')
    : defaultEndTime
  const defaultEndIndex = slots.findIndex((slot) =>
    getSlotMoment(slot.slotStartTime, date).isSameOrAfter(getSlotMoment(maxDefaultEndTime, date))
  )

  const defaultIncrement = 20
  const [startIndex, setStartIndex] = useState(defaultStartIndex)
  const [endIndex, setEndIndex] = useState(defaultEndIndex)

  const handleShowEarlierTimes = () => {
    if (startIndex > 0) {
      const decrement = startIndex - defaultIncrement
      setStartIndex(decrement < 0 ? 0 : decrement)
    }
  }

  const handleShowMoreTimes = () => {
    if (endIndex < slots.length) {
      const increment = endIndex + defaultIncrement
      setEndIndex(increment > slots.length ? slots.length : increment)
    }
  }

  useEffect(() => {}, [startIndex, endIndex])

  return (
    <div className="flex flex-col justify-center">
      <button
        onClick={handleShowEarlierTimes}
        className={`text-${startIndex <= 0 ? 'brown' : 'primary'} font-bold`}
      >
        Show Earlier Times
      </button>
      {slots.slice(startIndex, endIndex).map((slot, index) => {
        const { slotStartTime } = slot
        const startTime = slotStartTime
        const label = `${startTime}`
        return (
          <Button
            key={index}
            label={label}
            className="rounded-none my-1 w-full"
            variant="flat"
            type="button"
            onClick={() => onClick(slot)}
          />
        )
      })}
      <button
        onClick={handleShowMoreTimes}
        className={`text-${endIndex >= slots?.length ? 'brown' : 'primary'} font-bold`}
      >
        Show More
      </button>
    </div>
  )
}

export default PaginatedSlots
